import React from "react";
import Select from "react-select";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "fontsource-muli";
import { withStyles } from "@material-ui/core/styles";
import Color from "../../../utils/Color";
import CustomText, { getFontSize, getFontWeight } from "../CustomText";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { makeStyles } from "@material-ui/core/styles";

const DropdownIndicator = () => {
  return <ExpandMoreIcon style={{ width: 18, height: 18, marginRight: 10 }} />;
};

const useOutlinedInputStyles = makeStyles((theme) => ({
  root: {
    "& $notchedOutline": {
      borderColor: "red",
    },
    "&:hover $notchedOutline": {
      borderColor: "blue",
    },
    "&$focused $notchedOutline": {
      borderColor: "green",
    },
  },
  focused: {},
  notchedOutline: {},
}));

const CustomDropDown = ({
  value,
  onChange = () => {},
  options,
  placeholder = "",

  isMulti = false,
  isSearchable = false,
  className,
  components,
  classes,
  error,
  borderline,
  disabled,
  defaultValue,
  ...props
}) => {
  const outlinedInputClasses = useOutlinedInputStyles();
  const { children, design } = props;
  return (
    <div className={`${classes.rootV2} ${design}`} {...props}>
      <Select
        isDisabled={disabled}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        styles={design}
        isMulti={isMulti}
        isSearchable={isSearchable}
        components={
          components
            ? { IndicatorSeparator: () => null, components }
            : { IndicatorSeparator: () => null, DropdownIndicator }
        }
        error={error}
        input={
          <OutlinedInput
            labelWidth={"labelWidth"}
            name="age"
            id="outlined-age-simple"
            classes={outlinedInputClasses}
            autoComplete="new-password"
          />
        }
        {...props}
      />
      {error ? <CustomText>"abc"</CustomText> : false}
    </div>
  );
};

const styles = {
  root: {
    // marginBottom: 18,
    "& $notchedOutline": {
      borderWidth: 1,
    },
    "&:hover $notchedOutline": {
      border: "solid 2px #90a0b1",
      borderColor: "#90a0b1",
    },
    "&$focused $notchedOutline": {
      border: "solid 2px",
      borderColor: "#69a6f0",
    },
    fontFamily:"Muli"
  },
  rootV2:{
    fontFamily:"Muli",
    fontWeight:"600",
    fontSize:16
  },
  errorRoot: {
    // marginBottom: 0,

    "& $notchedOutline": {
      borderWidth: 1,
      border: "solid 2px #f46a6a",
      borderRadius: "5px",
    },
    "&:hover $notchedOutline": {
      border: "solid 1.9px #f46a6a",
      borderColor: Color.errorBorderColor,
    },
    "&$focused $notchedOutline": {
      border: "solid 1.9px #f46a6a",
      borderColor: Color.errorBorderColor,
    },
  },
  textStyle: {
    textTransform: "none",
    ...getFontWeight("600"),
    fontFamily: "Muli",
    fontSize: 15,
    marginBottom: 5,
    color: Color.primaryTextColor,
  },
  focused: {
    // borderRadius: "5px",
    // border: "solid 2px #69a6f0",
  },
  notchedOutline: {},
  notchedOutlineNone: {
    border: 0,
  },
  inputStyle: {
    textTransform: "none",
    ...getFontWeight("600"),
    fontFamily: "Muli",
    fontSize: 15,
    color: Color.primaryTextColor,
    paddingTop: 8,
    paddingBottom: 5,
    marginTop: 2,
  },
  errorTextStyle: {
    textTransform: "none",
    ...getFontWeight("normal"),
    fontFamily: "Muli",
    ...getFontSize("xxsmall"),
    color: Color.errorBorderColor,
  },
  errorRequiredTextStyle: {
    textTransform: "none",

    fontFamily: "Muli",
    fontSize: "12px",
    color: Color.primaryTextColor,
  },
};

export default withStyles(styles)(CustomDropDown);
